/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import e from "react";
const n = e.forwardRef((t, o) => {
  const { children: r } = t;
  return /* @__PURE__ */ e.createElement("div", { className: "k-prompt-content", ref: o }, /* @__PURE__ */ e.createElement("div", { className: "k-prompt-view" }, r));
});
n.displayName = "KendoReactAIPromptContent";
export {
  n as AIPromptContent
};
